<template lang="pug">
  .crud(v-if="has_permission")
    modal-submittal-details(:newRecord='newRecord', :is-add='isModalAdd' :submittal='submittal_id')
    vm-row.separador-quote-file(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          a(href="javascript:history.go(-1)")
            vm-button(icon="arrow-back-outline" radius)
    .container-general
      span.title  {{ $t('strings.add') }}
      span.title-color  {{ $t('strings.submittal') }}
      br
      button-line-dot(text=" add Submittal" @click="addSubmittalDetail")
      .grid
        vm-col.separador-details-list.right-border(vm-align="center")
          vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-w=4)
              file-card(v-if="submittal.details_cano.length && submittals_index_permission" :data="canoDetails" showDelete :showSee="false" @view="openViewer(submittal.details_cano[0])"  @attachment="deleteSubmittalConfirm")
            span.table-title(v-if="submittals_index_permission") Submittals By Cano History
            vm-table(v-if="submittals_index_permission" :data="canoList" style="width: 100%")
              template(slot="header")
                .d-flex.justify-content-between
                  div
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns" :style="index === 0 ? 'width: 60%' : ''") {{ $t('submittals.' + column) }}
                vm-th
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column == 'subtotal' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status'") {{data[indextr][column]}}
                  vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                          vm-icon(icon="eye-outline")
                          slot &nbsp;{{ $t('strings.view') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr], tr)")
                          vm-icon(icon="arrow-downward-outline")
                          slot &nbsp;{{ $t('strings.download') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="deleteSubmittalConfirm(data[indextr])")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
        vm-col.separador-details-list(vm-align="center")
          vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-w=4)
              file-card(v-if="submittal.details_customer.length && submittals_index_permission" :data="customerDetails" showDelete :showSee="false" @view="openViewer(submittal.details_customer[0])"  @attachment="deleteSubmittalConfirm")
            span.table-title(v-if="submittals_index_permission") Customer Reply History
            vm-table(v-if="submittals_index_permission" :data="customerList" style="width: 100%")
              template(slot="header")
                .d-flex.justify-content-between
                  div
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns" :style="index === 0 ? 'width: 60%' : ''") {{ $t('submittals.' + column) }}
                vm-th
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                    slot(v-if="column == 'subtotal' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                    slot(v-if="column != 'status'") {{data[indextr][column]}}
                  vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                          vm-icon(icon="eye-outline")
                          slot &nbsp;{{ $t('strings.view') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr], tr)")
                          vm-icon(icon="arrow-downward-outline")
                          slot &nbsp;{{ $t('strings.download') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="deleteSubmittalConfirm(data[indextr])")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
</template>

<script>
import ModalSubmittalDetails from '@/components/in-order/ModalSubmittalDetails.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SubmittalDetails')

export default {
  name: 'SubmittalDetails',
  components: {
    ModalSubmittalDetails,
    ButtonLineDot: () => import('@/components/aditionals/ButtonLineDot.vue'),
    FileCard: () => import('@/components/aditionals/FileCard.vue')
  },
  data: () => ({
    isModalAdd: true,
    submittal_id: null,
    has_permission: true,
    submittals_store_permission: true,
    submittals_index_permission: true,
    customer_comments_submittal: true,
    customer: true,
    newRecord: {},
    columns: [
      'filename',
      'comments',
      'date'
    ]
  }),
  async created () {
    this.checkPermissionView('quoteds.index')
    this.$route.params.idsubmittal && (await this.getSubmittal())
  },
  methods: {
    ...mapActions([
      'loadSubmittal',
      'setModalVisible',
      'deleteSubmittalDetail'
    ]),
    addSubmittalDetail () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
      this.submittal_id = parseInt(this.$route.params.idsubmittal)
    },
    async getSubmittal () {
      this.loadSubmittal(this.$route.params)
    },
    openViewer (record) {
      this.$viewer.show({
        urlFile: record.file_url,
        mime: 'application/pdf',
        name: record.filename,
        color: '#FFF'
      })
    },
    download (record) {
      window.open(record.file_url, '_blank')
    },
    deleteSubmittalConfirm (submittal) {
      let t = this
      this.auxDeleteSubmittal = () => {
        t.deleteSubmittalDetail(submittal).then(() => { this.loadSubmittal(this.$route.params) })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.submittal'), attribute: this.$t(submittal.id) }),
        accept: this.auxDeleteSubmittal
      })
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.submittals_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'submittals.store') > -1
      this.submittals_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'submittals.index') > -1
      this.customer_comments_submittal = this.$auth.user().view_permissions.findIndex(e => e.name === 'customer_comments_submittal.store') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    }
  },
  computed: {
    ...mapGetters([
      'submittal',
      'pagination'
    ]),
    canoDetails () {
      return {
        filename: 'Cano submittal',
        mime_type: 'application/pdf',
        date: this.submittal.details_cano[0].date ? this.submittal.details_cano[0].date : '',
        file_url: this.submittal.details_cano[0].file_url ? this.submittal.details_cano[0].file_url : '',
        id: this.submittal.details_cano[0].id ? this.submittal.details_cano[0].id : null,
        comments: this.submittal.details_cano[0].comments ? this.submittal.details_cano[0].comments : '',
        submittal_id: this.submittal.details_cano[0].submittal_id ? this.submittal.details_cano[0].submittal_id : ''
      }
    },
    customerDetails () {
      return {
        filename: 'Customer submittal',
        mime_type: 'application/pdf',
        date: this.submittal.details_customer[0].date ? this.submittal.details_customer[0].date : '',
        file_url: this.submittal.details_customer[0].file_url ? this.submittal.details_customer[0].file_url : '',
        id: this.submittal.details_customer[0].id ? this.submittal.details_customer[0].id : null,
        comments: this.submittal.details_customer[0].comments ? this.submittal.details_customer[0].comments : '',
        submittal_id: this.submittal.details_customer[0].submittal_id ? this.submittal.details_customer[0].submittal_id : ''
      }
    },
    canoList () {
      return this.submittal.details_cano
    },
    customerList () {
      return this.submittal.details_customer
    }
  }
}
</script>

<style lang="css" scoped>
.container-general {
  background: white;
  padding: 30px 35px;
  border-radius: 15px;
  min-height: 300px;
  margin: 50px;
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
  overflow: auto;
}
.title {
  font-weight: bold;
  font-size: 20px;
}
.title-color {
  font-weight: bold;
   font-size: 20px;
  color: rgba(var(--primary), 1);
}
.table-title {
  margin: 30px 10px 0px 30px;
  font-weight: bold;
  color: rgba(var(--primary), 1);
  padding: 10px 5px;
  border-bottom: 1.5px solid rgb(192, 192, 192);
  width: 100%;
}
.separador-quote-file {
  padding: 20px 0px 0px 50px;
}
.separador-details-list {
  padding: 0px 15px 0px 15px;
}
.right-border {
  border-right: 1px dotted rgb(151, 151, 151);
}
.left-border {
  border-left: 1px dotted rgb(151, 151, 151);
}
.grid {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 50% 50%;
}
</style>
